import { Router } from "@frui.ts/screens";
import { Modules } from "config";
import EnumRepository from "repositories/enumRepository";
import ConfirmationService from "services/confirmationService";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import SecurityService from "services/securityService";
import type Enum from "entities/enum";
import type SourceType from "entities/sourceType";
import ListViewModel from "../../listViewModel";
import { computed } from "mobx";
import BankAccountResponse from "entities/bankAccountResponse";
import type BankAccountStatus from "entities/bankAccountStatus";

const navigationName = "bank-accounts";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
})
export default class BankAccountsViewModel extends ListViewModel<BankAccountResponse> {
  readonly modelName = "bankAccountEnum";

  @computed
  get allowWrite() {
    return false;
  }

  constructor(
    protected localizationService: LocalizationService,
    protected eventBus: EventBus,
    protected confirmationService: ConfirmationService,
    protected notificationService: NotificationService,
    protected securityService: SecurityService,
    protected repository: EnumRepository
  ) {
    super();
    this.navigationName = navigationName;
  }

  protected fetchData() {
    return this.repository.getAll<BankAccountResponse>("bank_accounts", BankAccountResponse, {}, "2");
  }

  delete(item: Enum): any {
    return this.repository.delete(item, "bank_accounts");
  }

  translate(code: string, size?: number): string {
    return this.localizationService.translateModule(Modules.finance, `bankAccounts.${code}`, size);
  }

  translateEnum(enumName: "sourceType", value: SourceType) {
    return this.localizationService.translateEnum(enumName as any, value as any);
  }
  translateBankAccStatus(enumName: "bankAccountStatus", value: BankAccountStatus) {
    return this.localizationService.translateEnum(enumName as any, value as any);
  }
}
